import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, PRODUCT_IMG } from './constants';
export function Hero() {
  return <section className="px-4 pb-8 pt-6 sm:pb-10" data-id="element-83" data-mp="9kjvgl9o4y23">
      <div className="mx-auto max-w-3xl text-center" data-id="element-84" data-mp="9lbkfd8rfxje">
        <h1 className="text-[26px] font-extrabold leading-[1.05] sm:text-4xl md:text-5xl" data-id="element-85" data-mp="4m8mecr76rkx">
          The Complete Operating System for Professional Speech Therapists
        </h1>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-snug text-ink-text sm:text-lg" data-id="element-86" data-mp="xae7x1q2sklt">
          Stop spending hours creating therapy activities, planning sessions, writing goals,
          and preparing printable resources from scratch.
        </p>
        <p className="mt-2 font-display text-base font-bold uppercase text-gold sm:text-xl" data-id="element-87" data-mp="nbooh4ij6s3g">
          Everything is already planned, organized, and ready to use.
        </p>

        <a href={OFFER_ANCHOR} className="mt-4 block" aria-label="Go to the offer" data-id="element-88" data-mp="3825w6klg5xiq">
          <img src={PRODUCT_IMG} alt="Speech Therapy Pro — complete 6-in-1 operating system with 6 modules and 5 premium bonuses" className="mx-auto w-full max-w-md rounded-xl transition-transform duration-200 hover:scale-[1.02]" data-id="element-89" data-mp="3j7zh7oa6s2jb" />
        </a>

        <CTAButton className="mx-auto mt-4 max-w-md" data-id="element-90" data-mp="39a362wh917l7">
          🚀 YES! I WANT MY SYSTEM NOW
        </CTAButton>

        <div className="mt-3 flex flex-col items-center gap-1 text-[11px] font-medium text-ink-text sm:flex-row sm:justify-center sm:gap-5 sm:text-sm" data-id="element-91" data-mp="3ebipyl7ox820">
          <span className="flex items-center gap-1.5" data-id="element-92" data-mp="358zu4l2bnvp9">
            <StarIcon className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-93" data-mp="35aknw8gtbam2" />
            ⭐⭐⭐⭐⭐ 4.9/5 — Verified Therapist Reviews
          </span>
          <span className="flex items-center gap-1.5" data-id="element-94" data-mp="2vjzmkd9r7rzg">
            <ShieldCheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-95" data-mp="2hj5clq725iyo" />
            🛡️ 7-Day Money-Back Guarantee — Zero Risk
          </span>
        </div>
      </div>
    </section>;
}